import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import API_BASE_URL from '../config/apiConfig';
import '../styles/VoucherEntryForm.css'; // Reusing styles but adding custom layout
import Swal from 'sweetalert2';

function BankForm() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(id ? true : false);
    const [formData, setFormData] = useState({
        bankName: '',
        branchName: '',
        ifscCode: '',
        accountNumber: '',
        openingBalance: '',
        bankAddress: ''
    });

    useEffect(() => {
        if (id) {
            const fetchBank = async () => {
                try {
                    const token = sessionStorage.getItem('token');
                    const res = await axios.get(`${API_BASE_URL}/bank/${id}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    if (res.data) setFormData(res.data);
                } catch (err) {
                    console.error("Error fetching bank:", err);
                    toast.error("Failed to load bank data");
                } finally {
                    setLoading(false);
                }
            };
            fetchBank();
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {

    if(e) e.preventDefault();
    const conf = await Swal.fire({
      title: 'Save Data?',
      text: 'Are you sure you want to save this data?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#00334e',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Save',
      cancelButtonText: 'No, Keep Editing'
    });
    if(!conf.isConfirmed) return;
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('token');
            const url = id ? `${API_BASE_URL}/bank/${id}` : `${API_BASE_URL}/bank`;
            const method = id ? 'put' : 'post';

            await axios[method](url, formData, {
                headers: { Authorization: `Bearer ${token}` }
            });

            toast.success(`Bank ${id ? 'updated' : 'added'} successfully!`);
            navigate(-1);
        } catch (err) {
            console.error("Error saving bank:", err);
            toast.error("Failed to save bank");
        }
    };

    if (loading) return <div className="loading">Loading...</div>;

    return (
        <div className="voucher-entry-container">
            <h2 className="voucher-entry-title" style={{ textDecoration: 'underline' }}>{id ? 'Edit' : 'Add'} Bank</h2>
            
            <form onSubmit={handleSubmit} className="voucher-entry-form" style={{ maxWidth: '900px', margin: '0 auto', background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                    <div className="ve-field">
                        <label>Bank Name</label>
                        <input 
                            name="bankName"
                            type="text" 
                            placeholder="Enter Bank Name"
                            value={formData.bankName}
                            onChange={handleChange}
                            required 
                        />
                    </div>
                    <div className="ve-field">
                        <label>Bank Branch Name</label>
                        <input 
                            name="branchName"
                            type="text" 
                            placeholder="Enter Bank Branch Name"
                            value={formData.branchName}
                            onChange={handleChange}
                            required 
                        />
                    </div>
                    <div className="ve-field">
                        <label>Bank IFSC Code</label>
                        <input 
                            name="ifscCode"
                            type="text" 
                            placeholder="Enter Bank IFSC Code"
                            value={formData.ifscCode}
                            onChange={handleChange}
                            required 
                        />
                    </div>
                    <div className="ve-field">
                        <label>Bank Account Number</label>
                        <input 
                            name="accountNumber"
                            type="text" 
                            placeholder="Enter Bank Account Number"
                            value={formData.accountNumber}
                            onChange={handleChange}
                            required 
                        />
                    </div>
                    <div className="ve-field">
                        <label>Bank Opening Balance</label>
                        <input 
                            name="openingBalance"
                            type="number" 
                            placeholder="Enter Bank Opening Balance"
                            value={formData.openingBalance}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="ve-field" style={{ marginBottom: '30px' }}>
                    <label>Bank Address</label>
                    <textarea 
                        name="bankAddress"
                        placeholder="Enter Bank Address"
                        value={formData.bankAddress}
                        onChange={handleChange}
                        style={{ width: '100%', height: '150px', border: '1px solid #d1d5db', borderRadius: '8px', padding: '12px', fontSize: '14px', outline: 'none' }}
                    />
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
                    <button type="submit" className="ve-submit-btn" style={{ width: '120px', margin: '0' }}>
                        Submit
                    </button>
                    <button type="button" className="ve-remove-btn" style={{ width: '120px', margin: '0', background: '#e5e7eb', color: '#374151' }} onClick={() => navigate(-1)}>
                        Cancel
                    </button>
                </div>
            </form>
        </div>
    );
}

export default BankForm;
